export default __webpack_public_path__ + "static/media/basic-pin-large-0.75ec4490.png";